import React, { useState, useEffect, useMemo } from 'react';
import './iconpickermodal.css';
import { ALL_BOOTSTRAP_ICON_NAMES } from '../utils/bootstrapIconNames';

// Emoji-picker-style browse/search grid over the full Bootstrap Icons set.
// Selecting an icon fires onSelect immediately; there is no separate save step.
export default function IconPickerModal({ show, value, onSelect, onClose, saving, error }) {
    const [search, setSearch] = useState('');

    useEffect(() => {
        if (show) setSearch('');
    }, [show]);

    const filtered = useMemo(() => {
        const term = search.trim().toLowerCase();
        if (!term) return ALL_BOOTSTRAP_ICON_NAMES;
        return ALL_BOOTSTRAP_ICON_NAMES.filter(name => name.includes(term));
    }, [search]);

    if (!show) return null;

    return (
        <div className="icon-picker-overlay" onClick={onClose}>
            <div className="icon-picker-modal" onClick={e => e.stopPropagation()}>
                <div className="icon-picker-header">Choose an Icon</div>
                <input
                    className="icon-picker-search"
                    type="text"
                    placeholder="Search icons… (e.g. train, capsule, water)"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    autoFocus
                />
                {error && <div className="icon-picker-error">{error}</div>}
                <div className="icon-picker-grid">
                    {saving ? (
                        <div className="icon-picker-status">
                            <i className="bi bi-arrow-repeat icon-picker-spin" /> Saving…
                        </div>
                    ) : filtered.length === 0 ? (
                        <div className="icon-picker-status">No icons match "{search}"</div>
                    ) : (
                        filtered.map(name => {
                            const iconClass = `bi-${name}`;
                            return (
                                <button
                                    key={name}
                                    type="button"
                                    className={`icon-picker-cell ${value === iconClass ? 'selected' : ''}`}
                                    title={name}
                                    onClick={() => onSelect(iconClass)}
                                >
                                    <i className={`bi ${iconClass}`} />
                                </button>
                            );
                        })
                    )}
                </div>
                <div className="icon-picker-footer">
                    <span className="icon-picker-count">
                        {filtered.length.toLocaleString()} icon{filtered.length !== 1 ? 's' : ''}
                    </span>
                    <button className="awards-cancel-btn" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}
